// in dev - Reminders/Additional Recipient
// in UAT/Prod and prod - Reminder / Additional Alert Recipient(s)

const typeMap = {
  expiryDate: "Expiration Date",
  reminder: "Reminder",
  primaryRecipient: "Primary Alert Recipient",
  additionalRecipient: "Additional Alert Recipient(s)",
  autoId: "Auto ID",
};

module.exports = { typeMap };
